module.exports = __webpack_public_path__ + "img/switzerland-other-heart-diseases-male.3b552c6b.png";